import { supabase } from "@/lib/supabase"

type InvokeEdgeOptions<T> = {
  parse?: (data: unknown) => T
  method?: "POST" | "GET"
}

export async function invokeEdgeFunction<T>(
  functionName: string,
  payload?: any,
  opts?: InvokeEdgeOptions<T>
): Promise<T> {
  const method = opts?.method ?? "POST"
  const parse = opts?.parse

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
  const explicitFunctionsUrl = import.meta.env.VITE_SUPABASE_FUNCTIONS_URL
  const baseUrl = explicitFunctionsUrl || `${supabaseUrl}/functions/v1`
  const url = `${baseUrl.replace(/\/+$/g, "")}/${encodeURIComponent(functionName)}`

  const session = await supabase.auth.getSession().then((r) => r.data.session).catch(() => null)
  const token = session?.access_token || ""

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    apikey: supabaseAnonKey,
  }
  if (token) headers.Authorization = `Bearer ${token}`

  const res = await fetch(url, {
    method,
    headers,
    body: method === "GET" ? undefined : JSON.stringify(payload ?? {}),
  })

  if (!res.ok) {
    const bodyText = await res.text().catch(() => "")
    const msg = bodyText || `Edge function failed (${res.status})`
    const err = new Error(msg)
      ; (err as any).status = res.status
    throw err
  }

  const json = await res.json().catch(() => null)
  if (!parse) return json as T
  return parse(json)
}
